import { useContext } from 'react';
import _find from 'lodash/find';
import { UserContext } from 'commons-ui';

export interface HasPermissionArgument {
	configPageName: string;
	configResourceName?: string;
	configActionName?: string;
	appName?: any;
}

export interface IQueryArgument {
	pageName: string;
	resourceName?: string;
	actionName?: string;
	appName?: any;
}

const usePermission = () => {
	const { roleConfig, permissionsConfig: permissions, logoutUser } = useContext(UserContext);

	const hasPermission = ({ configPageName, configResourceName, configActionName, appName }: HasPermissionArgument): boolean => {
		const { roleActions } = roleConfig || { role: 'ADMIN', roleActions: {} };
		if (
			configResourceName === 'chatDashboard' ||
			configResourceName === 'aiCompanionDashboard' ||
			configResourceName === 'talkzyData' ||
			configResourceName === 'gameplayGuardrailReview' ||
			configResourceName === 'mandateRefund' ||
			configResourceName === 'kycBankNameMismatch'
		) {
			return true;
		}
		if (!permissions && !roleActions) {
			logoutUser();
			return false;
		}
		if (!permissions) {
			return false;
		}

		const query: IQueryArgument = { pageName: configPageName };
		if (appName) {
			query.appName = appName;
		}
		if (configResourceName) {
			query.resourceName = configResourceName;
		}
		if (configActionName) {
			query.actionName = configActionName;
		}
		const permission = _find(permissions, query);
		if (permission) return true;
		return false;
	};

	return {
		hasPermission
	};
};

export default usePermission;
